<div fxLayout="row">
  <!--Min Value-->
  <num-value-select
    [value]="minValue"
    (selectedValue)="setMinValue($event)"
    [label]="'FEASIBILITY.EDITOR.QUANTITY.MIN'"
  ></num-value-select>

  <span>{{ 'FEASIBILITY.EDITOR.QUANTITY.AND' | translate }}</span>

  <!--Max Value-->
  <num-value-select
    [value]="maxValue"
    (selectedValue)="setMaxValue($event)"
    [label]="'FEASIBILITY.EDITOR.QUANTITY.MAX'"
  ></num-value-select>
</div>
<div *ngIf="displayWarning" fxLayout="column">
  <span class="warning">{{ 'FEASIBILITY.HINT.MINIMUM_GREATER_MAXIMUM' | translate }}</span>
</div>
